import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import FusePageCarded from "@fuse/core/FusePageCarded/FusePageCarded";
import AgGridTable from "../../utilities/AgGridTable";
import Cards from "./Card";
import data from "./data";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import { styled, useTheme, alpha } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  OutlinedInput,
  Paper,
  Tab,
  Tabs,
  Tooltip,
} from "@mui/material";
import FormPageHeader from "../../utilities/FormPageHeader";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import AdvancedSearch from "./AdvancedSearch";
import GridView from "./GridView";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";
import jwtDecode from "jwt-decode";
import CustomDatePicker from "../../utilities/CustomDatePicker";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .new, & .assigned, & .placed, & .ab_received, & .invoiced, & .inprogress":
    {
      borderRadius: "20px",
      fontSize: "11px",
      textAlign: "center",
      height: "19px",
      lineHeight: "19px",
      padding: "0px 10px",
      marginTop: "1px",
      color: theme.palette.common.white,
    },
    "& .new": {
      backgroundColor: theme.palette.info.main,
    },
    "& .assigned": {
      backgroundColor: theme.palette.warning.main,
    },
    "& .placed": {
      backgroundColor: theme.palette.grey[500],
    },
    "& .ab_received": {
      backgroundColor: theme.palette.success.main,
    },
    "& .invoiced": {
      backgroundColor: theme.palette.success.main,
    },
    "& .inprogress": {
      backgroundColor: theme.palette.success.main,
    },
    "& .total-list": {
      padding: "5px",
      justifyContent: "space-around",

      "& li": {
        padding: "5px",
        fontSize: "12px",

        "& label": {
          fontSize: "12px",
          color: `${theme.palette.common.white} !important`,
          paddingBottom: "4px",
          display: "block",
        },
      },
    },
  },
}));

const StyledTextField = styled(OutlinedInput)(({ theme }) => ({
  "& input": {
    padding: "11px 14px",
  },
}));

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    padding: '0 10px',
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

const createServerSideDataSource = (server) => {
  return {
    getRows: (params) => {
      console.log('[Datasource] - rows requested by grid: ', params.request);
      const response = server.getData(params.request);
      setTimeout(function () {
        if (response.success) {
          params.success({ rowData: response.rows });
        } else {
          params.fail();
        }
      }, 500);
    },
  };
};

const createFakeServer = (allData) => {
  console.log('allData', allData)
  return {
    getData: (request) => {
      const requestedRows = allData.slice(request.startRow, request.endRow);
      return {
        success: true,
        rows: requestedRows,
      };
    },
  };
};

const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orders}`;
const newOrderUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.newCustomerOrder}`;
const getMyOrdersUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getMyOrders}`;
const companiesUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;

const CustomerOrder = (props) => {
  const theme = useTheme();
  // const [tabValue, setTabValue] = useState("ViewAllFields");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [showSearch, setShowSearch] = useState(false);
  const [listView, setListView] = useState(true);
  const [gridView, setGridView] = useState(false);
  const classes = useStyles(props);
  const navigate = useNavigate();
  const [rowData, setRowData] = useState([]);
  const perPage = 20;
  const gridRef = useRef();
  const [selectedRows, setSelectedRows] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [autoSizeMode, setAutoSizeMode] = useState(true)
  const [showroom, setShowroom] = useState(true)
  const [customer, setCustomer] = useState(true)
  const [showroomOptions, setShowroomOptions] = useState([])
  const [customerOptions, setCustomerOptions] = useState([])
  const [checkboxStates, setCheckboxStates] = useState({
    group1: true,
    group2: true,
    group3: true,
    group4: true,
    group5: true,
    group6: true,
    group7: true,
  });
  const [range1Id, setRange1Id] = useState([]);
  const [orderStatus, setOrderStatus] = useState('NEW');

  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));

  const showDiscountPercent = (props) => {
    return <p>{props.value && <>{Number(props?.value).toFixed(3)}%</>}</p>;
  };
  const showFixedValue = (props) => {
    return <p>{props.value && <>{Number(props?.value).toFixed(2)}</>}</p>;
  };

  const customListPriceWG1 = (params) => {
    if (params.data.lpWg1 === 0 || params.data.lpWg1 === null) {
      return params.data.revisedLpWg1;
    }
    return params.data.lpWg1;
  }

  const customListPriceWG2 = (params) => {
    if (params.data.lpWg2 === 0 || params.data.lpWg2 === null) {
      return params.data.revisedLpWg2;
    }
    return params.data.lpWg2;
  }

  const CreateNewType = (props) => {
    const { data } = props
    const id = data.data.id

    const handleCreateNewType = () => {
      navigate("/order/new-type-order/" + id);
    };

    const handleEditOrder = () => {
      navigate("/order/edit-order/" + id);
    };

    return (
      <>
        <Tooltip title={"Create a New Type"}>
          <IconButton onClick={handleCreateNewType}>
            <FuseSvgIcon size={14} color="action">
              heroicons-solid:plus-circle
            </FuseSvgIcon>
          </IconButton>
        </Tooltip>
        <Tooltip title={"Edit"}>
          <IconButton onClick={handleEditOrder}>
            <FuseSvgIcon size={14} color="action">
              heroicons-solid:pencil
            </FuseSvgIcon>
          </IconButton>
        </Tooltip>
      </>
    );
  };

  const [columnDefs, setColumnDefs] = useState([
    {
      cellRenderer: (data) => <CreateNewType data={data} />,
      maxWidth: 70,
      pinned: true,
    },
    {
      field: 'orderStatus',
      headerName: "Status",
      headerTooltip: "Status",
      minWidth: 70,
      maxWidth: 75,
      pinned: true,
      cellClass: (params) => {
        if (params.value === "NEW") {
          return "new";
        } else if (params.value === "ASSIGNED") {
          return "assigned";
        } else if (params.value === "PLACED") {
          return "placed";
        } else if (params.value === "AB_RECEIVED") {
          return "ab_received";
        } else if (params.value === "INVOICED") {
          return "invoiced";
        } else if (params.value === "IN_PROGRESS") {
          return "inprogress";
        }
        return null;
      },
    },
    {
      headerName: "AB Number",
      pinned: true,
      maxWidth: 75,
      field: "abNumber",
      headerTooltip: "AB Number",
      minWidth: 75,
    },
    {
      headerName: "Commission Name",
      pinned: true,
      field: "commissionName",
      headerTooltip: "Commission Name",
      minWidth: 215,
      cellStyle: { textAlign: 'left' }
    },
    {
      headerName: "ORDER CHARACTERISTICS",
      children: [
        {
          headerName: "Product / Vendor",
          field: "vendorName",
          headerTooltip: "Product / Vendor",
          minWidth: 60,
        },
        {
          headerName: "Vendor Account No",
          field: "vendorNum",
          headerTooltip: "Vendor Account No",
          minWidth: 60,
        },
        {
          headerName: "Customer",
          field: "customerName",
          headerTooltip: "Customer",
          minWidth: 65,
        },
        {
          headerName: "Territory",
          field: "territory",
          headerTooltip: "Territory",
          minWidth: 60,
        },
        {
          headerName: "Region / Zone",
          field: "region",
          headerTooltip: "Region / Zone",
          minWidth: 60,
        },
        {
          headerName: "Showroom / City",
          field: "showroomName",
          headerTooltip: "Showroom / City",
          minWidth: 60,
        },
        {
          headerName: "Order Type (SO/AO)",
          field: "documentType",
          headerTooltip: "Order Type (SO/AO)",
          minWidth: 60,
        },
        {
          headerName: "Category",
          field: "orderCategory",
          headerTooltip: "Category",
          minWidth: 60,
        },
        {
          headerName: "Unique ID",
          field: "uniqueId",
          headerTooltip: "Unique ID",
          minWidth: 60,
        },
        {
          headerName: "No/ of Kitchen",
          field: "noOfKitchens",
          headerTooltip: "No/ of Kitchen",
          minWidth: 60,
        },
        {
          headerName: "No/of Furniture",
          field: "noOfFurniture",
          headerTooltip: "No/of Furniture",
          minWidth: 60,
        },
        {
          headerName: "No/ of Spa",
          field: "noOfSpaItems",
          headerTooltip: "No/ of Spa",
          minWidth: 60,
        },
        {
          headerName: "No/ of Living",
          field: "noOfLivingRmItems",
          headerTooltip: "No/ of Living",
          minWidth: 60,
        },
        {
          headerName: "List Price WG1",
          field: "lpWg1",
          headerTooltip: "List Price WG1",
          minWidth: 70,
          valueGetter: customListPriceWG1,
          cellRenderer: showFixedValue
        },
        {
          headerName: "List price WG2",
          field: "lpWg2",
          headerTooltip: "List price WG2",
          minWidth: 70,
          valueGetter: customListPriceWG2,
          cellRenderer: showFixedValue
        },
        {
          headerName: "Total List Price",
          field: "totalLpWg1Wg2",
          headerTooltip: "Total List Price",
          minWidth: 70,
          cellRenderer: showFixedValue
        },
        {
          headerName: "Range1",
          field: "range1",
          headerTooltip: "Range1",
          minWidth: 80,
        },
        {
          headerName: "Price Group",
          field: "priceGroup1",
          headerTooltip: "Price Group",
          minWidth: 60,
        },
        {
          headerName: "Front Color1",
          field: "color1",
          headerTooltip: "Front Color1",
          minWidth: 110,
        },
        {
          headerName: "Carcass Color1",
          field: "carcass1",
          headerTooltip: "Carcass Color1",
          minWidth: 90,
        },
        {
          headerName: "Handle1",
          field: "handle1",
          headerTooltip: "Handle1",
          minWidth: 180,
        },
      ],
    },
    {
      headerName: "LOGISTICS",
      children: [
        {
          headerName: "Volume",
          field: "volume",
          headerTooltip: "Volume",
          minWidth: 60,
          cellClass: "bg-logistics",
          cellRenderer: showFixedValue
        },
        {
          headerName: "Weight",
          field: "weight",
          headerTooltip: "Weight",
          minWidth: 60,
          cellClass: "bg-logistics",
          cellRenderer: showFixedValue
        },
        {
          headerName: "No of Packs",
          field: "noOfPacks",
          headerTooltip: "No of Packs",
          minWidth: 60,
          cellClass: "bg-logistics",
        },
        {
          headerName: "Internal Cont/ No",
          field: "internalContainerNo",
          headerTooltip: "Internal Cont/ No",
          minWidth: 60,
          cellClass: "bg-logistics",
        },
        {
          headerName: "Mode of Shipping",
          field: "freightId",
          headerTooltip: "Mode of Shipping",
          minWidth: 60,
          cellClass: "bg-logistics",
        },
      ],
    },
    {
      headerName: "HISTORY",
      children: [
        {
          headerName: "Order Received Date",
          field: "orderReceivedDate",
          headerTooltip: "Order Received Date",
          minWidth: 80,
          cellClass: "history",
        },
        /*
        {
          headerName: "AB Received Date",
          field: "abReceivedDate",
          headerTooltip: "AB Received Date",
          minWidth: 80,
          cellClass: "history",
        },
        {
          headerName: "Confirmed Date",
          field: "orderConfirmedDate",
          headerTooltip: "Confirmed Date",
          minWidth: 80,
          cellClass: "history",
        },
        {
          headerName: "Loading Plan Date",
          field: "plannedLoadingDate",
          headerTooltip: "Loading Plan Date",
          minWidth: 80,
          cellClass: "history",
        },
        {
          headerName: "Loading Plan Week",
          field: "plannedLoadingWeek",
          headerTooltip: "Loading Plan Week",
          minWidth: 80,
          cellClass: "history",
        },
        {
          headerName: "Cut off Date",
          field: "cutoffDate",
          headerTooltip: "Cut off Date",
          minWidth: 80,
          cellClass: "history",
        },
        {
          headerName: "Release date",
          field: "releaseDate",
          headerTooltip: "Release date",
          minWidth: 80,
          cellClass: "history",
        },
        {
          headerName: "Actual Loading Date",
          field: "actualLoadingDate",
          headerTooltip: "Actual Loading Date",
          minWidth: 80,
          cellClass: "history",
        },
        {
          headerName: "Actual Loading week",
          field: "actualLoadingWeek",
          headerTooltip: "Actual Loading week",
          minWidth: 80,
          cellClass: "history",
        },*/
      ],
    },
    {
      headerName: "AO DETAILS",
      children: [
        {
          headerName: "AO Reason 1",
          field: "reason1",
          headerTooltip: "AO Reason 1",
          cellClass: "ao-details",
          minWidth: 90,
        },
        {
          headerName: "Picture",
          field: "reason1ImgPath",
          headerTooltip: "Picture",
          cellClass: "ao-details",
          minWidth: 90,
        },
        {
          headerName: "AO Reason 2",
          field: "reason2",
          headerTooltip: "AO Reason 2",
          cellClass: "ao-details",
          minWidth: 90,
        },
        {
          headerName: "Picture",
          field: "reason2ImgPath",
          headerTooltip: "Picture",
          cellClass: "ao-details",
          minWidth: 90,
        },
        {
          headerName: "AO Reason 3",
          field: "reason3",
          headerTooltip: "AO Reason 3",
          cellClass: "ao-details",
          minWidth: 90,
        },
        {
          headerName: "Picture",
          field: "reason3ImgPath",
          headerTooltip: "Picture",
          cellClass: "ao-details",
          minWidth: 90,
        },
      ],
    },
  ]);

  const loadData = async () => {
    let list = '';
    let orders = ''
    try {
      if (token) {
        if (hasPartnerOrderProRole) {
          list = await OAuthService.getList(getMyOrdersUrl + `?page=0&size=1000&orderStatus=NEW,ASSIGNED,LOADED&sort=desc`);
          orders = list.data?.content;
        } else if (hasPartnerAdminRole) {
          list = await OAuthService.getList(url + `/search/findByCustomerNumAndDeletedFalseOrderByCreatedDateDesc?customerNum=${token?.company}&sort=desc`);
          orders = list.data?._embedded?.orders;
        } else {
          list = await OAuthService.getList(url + `?page=0&size=20&sort=createdDate%20desc`);
          orders = list.data?._embedded?.orders;
        }
      }
      setRowData(orders);
    } catch (error) {
      setError(error.message);
    }
  }

  const getCustomer = async () => {
    const list = await OAuthService.getList(
      companiesUrl + `?sort=name,asc&size=1000`
    );
    const companies = list.data?._embedded?.companies;
  };

  const getShowroom = async () => {
    try {
      const list = await OAuthService.getList(newOrderUrl);
      const newOrder = list.data;
      const showrooms = Object.keys(newOrder.showrooms).map((key) => ({
        value: key,
        label: newOrder.showrooms[key],
      }));
      setShowroomOptions(showrooms);
      setShowroom({ value: newOrder.showroomId, label: newOrder.showroomName });
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);

  useEffect(() => {
    getShowroom()
    getCustomer()
  }, [])

  const onGridReady = useCallback((params) => {
    setGridApi(params.api)
  }, []);

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

  const onRowDoubleClicked = (params) => {
    var filename = selectedRows[0]?.id;
    navigate("/order/order-details/" + filename);
  };

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "Orders.xlsx",
      sheetName: "Orders",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const orderHeaderAction = () => {
    // const navigate = useNavigate();
    return (
      <>
        <Tooltip title={"Export Order List"}>
          <Button
            variant="contained"
            color="warning"
            onClick={onBtExport}
            size="small"
            sx={{ minWidth: "auto" }}
          >
            <FuseSvgIcon size={18}>heroicons-solid:save</FuseSvgIcon>
          </Button>
        </Tooltip>
      </>
    );
  };

  const toggleAutoSize = () => {
    if (gridRef.current) {
      if (autoSizeMode) {
        const allColumnIds = []
        gridRef.current.columnApi.getColumns().forEach((column) => {
          allColumnIds.push(column.getId());
        })
        gridRef.current.columnApi.autoSizeColumns(allColumnIds);
      } else {
        gridRef.current.api.sizeColumnsToFit();
      }
      setAutoSizeMode(!autoSizeMode)
    }
  }

  const hasPartnerRole = ["ROLE_PARTNRORDPROCESS", "ROLE_PARTNER_ADMIN"].some(role =>
    token.scope.includes(role)
  );
  const hasPartnerOrderProRole = ["ROLE_PARTNRORDPROCESS"].some(role =>
    token.scope.includes(role)
  );
  const hasPartnerAdminRole = ["ROLE_PARTNER_ADMIN"].some(role =>
    token.scope.includes(role)
  );
  const handleStatusChange = async (status) => {
    const statusConvert = status.join(',')
    const list = await OAuthService.getList(getMyOrdersUrl + `?page=0&size=20&orderStatus=${statusConvert}`);
    console.log('status', list)
  }

  return (
    <>
      <FormPageHeader
        componentName="Order Management System"
        pageName="Order Management System"
        currentPage="Order Management System"
        orderHeaderAction={orderHeaderAction()}
      >
        <div className="flex flex-col sm:flex sm:flex-row mb-8 px-24">
          <Cards statusChange={handleStatusChange} hasPartnerRole={hasPartnerRole} />
        </div>
        <Box className="flex px-24" sx={{ pb: 1 }}>
          <Box sx={{ pr: 1 }}>
            <StyledTextField
              type="text"
              sx={{ minHeight: 30 }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton edge="end">
                    <FuseSvgIcon size={14}>
                      heroicons-outline:search
                    </FuseSvgIcon>
                  </IconButton>
                </InputAdornment>
              }
            />
          </Box>
          <Box sx={{ px: 1 }}>
            <Select
              required
              value={customer}
              onChange={(event) => setCustomer({ value: event.value, label: event.label })}
              placeholder={'Customer'}
              options={customerOptions}
              styles={customStyles()}
              className="w-full"
            />
          </Box>
          <Box sx={{ px: 1 }}>
            <Select
              required
              value={showroom}
              onChange={(event) =>
                setShowroom({ value: event.value, label: event.label })
              }
              placeholder={'Showroom'}
              options={showroomOptions}
              styles={customStyles()}
              className="w-full"
              isDisabled={token.scope.includes("ROLE_PARTNRORDPROCESS")}
            />
          </Box>
          <Box sx={{ px: 1 }}>
            <Select
              required
              placeholder={'Created By'}
              // options={sortOptions}
              styles={customStyles()}
              className="w-full"
              labe
            />
          </Box>
          <Box sx={{ px: 1 }}>
            <CustomDatePicker
              label="Created From"
              className="w-[150px]"
              format={'dd-MM-yyyy'}
              name={'fromDate'}
              placeholder="test"
              // value={fromDate}
              // handleChange={handleFromDateChange}
              componentsProps={{
                actionBar: { actions: ["clear"] },
              }}
            />
          </Box>
          <Box sx={{ px: 1 }}>
            <CustomDatePicker
              label="Created To"
              className="w-[150px]"
              format={'dd-MM-yyyy'}
              name={'toDate'}
              // value={toDate}
              // minDate={fromDate}
              // handleChange={handleToDateChange}
              componentsProps={{
                actionBar: { actions: ["clear"] },
              }}
            />
          </Box>
          <Box sx={{ px: 1 }}>
            <Button
              onClick={toggleAutoSize}
              variant="contained"
              color="error"
              sx={{ height: 30, minHeight: 30, maxHeight: 30, fontSize: 11 }}
            >
              {autoSizeMode ? 'Auto-Size Columns' : 'Reset Columns'}
            </Button>
          </Box>
        </Box>
      </FormPageHeader>
      <div
        className={clsx(
          classes.root,
          "h-full order-grid grid-center",
          theme.palette.mode === "dark"
            ? "ag-theme-alpine-dark"
            : "ag-theme-alpine"
        )}
      >
        <AgGridTable
          rowData={rowData}
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          gridRef={gridRef}
          onRowDoubleClicked={onRowDoubleClicked}
          onSelectionChanged={onSelectionChanged}
          hideCheckbox={true}
          editable={false}
          wrapHeaderText={true}
          autoHeaderHeight={true}
          paginationPageSize={perPage}
          cacheBlockSize={perPage}
        />
        <Box
          sx={{
            background:
              theme.palette.mode === "dark"
                ? theme.palette.grey[800]
                : theme.palette.grey[200],
          }}
        >
          <ul className="flex total-list">
            <li>
              <label>Total Qty</label>
              <Box
                sx={{
                  background: theme.palette.background.default,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 8,
                }}
              >
                10.00
              </Box>
            </li>
            <li>
              <label>Total List Price</label>
              <Box
                sx={{
                  background: theme.palette.background.default,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 8,
                }}
              >
                33,234.00
              </Box>
            </li>
            <li>
              <label>Total Receivables</label>
              <Box
                sx={{
                  background: theme.palette.background.default,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 8,
                }}
              >
                10.00
              </Box>
            </li>
            <li>
              <label>Total Payables</label>
              <Box
                sx={{
                  background: theme.palette.background.default,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 8,
                }}
              >
                10.00
              </Box>
            </li>
            <li>
              <label>Total Packs</label>
              <Box
                sx={{
                  background: theme.palette.background.default,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 8,
                }}
              >
                10.00
              </Box>
            </li>
            <li>
              <label>Total Volume</label>
              <Box
                sx={{
                  background: theme.palette.background.default,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 8,
                }}
              >
                10.00
              </Box>
            </li>
            <li>
              <label>Total Weight</label>
              <Box
                sx={{
                  background: theme.palette.background.default,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 8,
                }}
              >
                10.00
              </Box>
            </li>
            <li>
              <label>Total Kitchen</label>
              <Box
                sx={{
                  background: theme.palette.background.default,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 8,
                }}
              >
                10.00
              </Box>
            </li>
          </ul>
          <Divider />
          <ul className="flex total-list">
            <li>
              <label>Total Wardrobes</label>
              <Box
                sx={{
                  background: theme.palette.background.default,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 8,
                }}
              >
                10.00
              </Box>
            </li>
            <li>
              <label>Total Bed Sets</label>
              <Box
                sx={{
                  background: theme.palette.background.default,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 8,
                }}
              >
                33,234.00
              </Box>
            </li>
            <li>
              <label>Total Chest</label>
              <Box
                sx={{
                  background: theme.palette.background.default,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 8,
                }}
              >
                10.00
              </Box>
            </li>
            <li>
              <label>Total TV/Living Room</label>
              <Box
                sx={{
                  background: theme.palette.background.default,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 8,
                }}
              >
                10.00
              </Box>
            </li>
            <li>
              <label>Gest to Cust</label>
              <Box
                sx={{
                  background: theme.palette.background.default,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 8,
                }}
              >
                10.00
              </Box>
            </li>
            <li>
              <label>%Gest to Cust.</label>
              <Box
                sx={{
                  background: theme.palette.background.default,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 8,
                }}
              >
                10.00
              </Box>
            </li>
            <li>
              <label>Fact. Gesture</label>
              <Box
                sx={{
                  background: theme.palette.background.default,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 8,
                }}
              >
                10.00
              </Box>
            </li>
            <li>
              <label>% Fact. Gest</label>
              <Box
                sx={{
                  background: theme.palette.background.default,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 8,
                }}
              >
                10.00
              </Box>
            </li>
          </ul>
        </Box>
      </div>
    </>
  );
};

export default CustomerOrder;
